// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__CuCmx","container":"styles_container__oA5hq","title":"styles_title__Pf5kq","text":"styles_text__1FhtQ"};